import styled from 'styled-components';

export const StyledBriefingsList = styled.div`
  .content-general {
    background-color: #ECEDF2;
    
    .content-briefings {
      padding: 35px 27px;  
      
      .title {
        display: flex;
        align-items: center;
      
        svg {
          color: #F3463C;
          font-size: 1.6em;
        }
      
        h4 {
          font-family: Poppins-Medium, Heltica, Arial, sans-serif;
          font-size: 1.6em;
          display: inline-block;
          margin-left: 10px;
          margin-bottom: 0;
        } 
      }
      
      .box-briefing {
        background-color: #FFFFFF;
        border-radius: 3px;
        padding: 20px;
        box-shadow: 0 3px 4px rgba(0, 0, 0, 0.2);
        margin-bottom: 45px;
        
        .table {
          margin: 20px 0;
          font-size: 1.4em;
          color: #707070;
          
          thead {
            color: #B2B2B2;
            
            th {
              border: 0;
            }
          }
          
          th, td {
              vertical-align: middle;
          }
          
          tr td {
            button.btn-danger {
                background-color: #FF003C;
                border-color: #FF003C;
                font-size: 1em;
                padding: 8px 20px;
                
                &:hover {
                  background: #ffffff;
                  color: #FF003C;
                }
            }
            
            button.btn-simple {
                background-color: #707070;
                border-color: #707070;
                font-size: 1em;
                padding: 8px 20px;
                color: #ffffff;
                
                &:hover {
                  background: #ffffff;
                  color: #707070;
                }
            }
          }
        }
      }
    }
  }
`;
